document.addEventListener('click', function (event) {
  // 合成 click など Element 以外が target になる場合があるため closest の有無を見る
  if (!event.target || typeof event.target.closest !== 'function') return;

  var opener = event.target.closest('[data-fc-dialog-open]');
  if (opener) {
    var dialog = document.getElementById(opener.getAttribute('data-fc-dialog-open'));
    // open 属性だけ残った非モーダル状態で showModal を呼ぶと InvalidStateError になる
    if (dialog && !dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }

  var closer = event.target.closest('[data-fc-dialog-close]');
  if (closer) {
    var owner = closer.closest('dialog');
    if (owner) owner.close();
    return;
  }

  if (event.target.matches && event.target.matches('dialog[data-fc-dialog]')) {
    event.target.close();
  }
});
